import { z } from "zod/v4";

export const newsletterStatusSchema = z.enum(["draft", "sent"]);

export const newsletterSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	author_id: z.string().uuid(),
	author_name: z.string(),
	subject: z.string(),
	body: z.string(),
	status: newsletterStatusSchema,
	sent_at: z.coerce.date().nullable().optional(),
	created_at: z.coerce.date(),
});

export const createNewsletterSchema = z.object({
	subject: z.string().min(1, "Subject is required"),
	body: z.string().min(1, "Body is required"),
});

export const updateNewsletterSchema = z.object({
	subject: z.string().min(1).optional(),
	body: z.string().min(1).optional(),
});
